import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ccf2ffc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "address-container" }
const _hoisted_2 = { class: "address-label" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "address-nickname"
}
const _hoisted_5 = {
  key: 2,
  class: "address-tx-add"
}
const _hoisted_6 = {
  key: 1,
  class: "address-tx"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]

import { ref, onMounted } from 'vue' 
import blankProfileImg from '@/assets/img/blank-profile.png'
import Account from 'arweave-account'


export default /*#__PURE__*/_defineComponent({
  __name: 'ArweaveAddress',
  props: {
  address: String,
  isAddress: Boolean,
  showProfileImage: Boolean,
  showHandleInAddress: Boolean,
  showHandleOnly: Boolean,
  showLinks: Boolean
},
  setup(__props) {

const props = __props;

const account = new Account()

const profileImage = ref(blankProfileImg)
const nickname = ref('')

onMounted(async () => {
  try {
    const user = await account.get(props.address)
    if (user) {
      nickname.value = user.handle ? user.handle : ''
      profileImage.value = user.profile && user.profile.avatarURL ?
        user.profile.avatarURL : blankProfileImg
    }
  } catch (err) {
    console.error('arweaveAddress', err)
  }
});

function ellipsis(s: string) {
  const minLength = 12;
  const sliceLength = 5;

  if (!s || typeof(s) !== 'string') {
    return '';
  }

  return s && s.length < minLength ? s : `${s.substring(0, sliceLength)}...${s.substring(s.length - sliceLength, s.length)}`;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("strong", _hoisted_2, [
      _renderSlot(_ctx.$slots, "label")
    ]),
    (__props.isAddress)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (profileImage.value  && __props.showProfileImage)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "avatar",
                src: profileImage.value
              }, null, 8, _hoisted_3))
            : _createCommentVNode("", true),
          (nickname.value && __props.showHandleInAddress)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(nickname.value), 1))
            : _createCommentVNode("", true),
          (__props.isAddress && !__props.showHandleOnly)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(ellipsis(__props.address)), 1))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (!__props.isAddress)
      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(ellipsis(__props.address)), 1))
      : _createCommentVNode("", true),
    (__props.isAddress && __props.showLinks)
      ? (_openBlock(), _createElementBlock("a", {
          key: 2,
          class: "btn-small",
          target: "_blank",
          href: `https://viewblock.io/arweave/address/${__props.address}`
        }, " Open in Viewblock ", 8, _hoisted_7))
      : _createCommentVNode("", true),
    (!__props.isAddress && __props.showLinks)
      ? (_openBlock(), _createElementBlock("a", {
          key: 3,
          class: "btn-small",
          target: "_blank",
          href: `https://viewblock.io/arweave/tx/${__props.address}`
        }, " Open in Viewblock ", 8, _hoisted_8))
      : _createCommentVNode("", true)
  ]))
}
}

})